import { JSX } from 'react';
import {
  useRouteError,
  isRouteErrorResponse,
  useNavigate,
} from 'react-router-dom';

import { ErrorComponent } from ':components';

export const ErrorBoundary = (): JSX.Element => {
  const error = useRouteError();
  const errorMessage = isRouteErrorResponse(error) ? error.data : 'Route error';
  // eslint-disable-next-line no-console
  console.error(errorMessage);
  const navigate = useNavigate();

  const handleClick = (): void => {
    navigate(0);
  };

  return (
    <ErrorComponent
      title='Кабинет сотрудника недоступен'
      subtitle='Обновите страницу или зайдите позже'
      buttonTitle='Обновить страницу'
      onButtonClick={handleClick}
    />
  );
};
